module.exports = __webpack_public_path__ + "static/media/sharing-208x165.edb0fd60.png";